export const safirIcon = icon => {
	const className = icon.startsWith("theme-") ? "themeicon" : "safiricon";
	return `<span class="${className} icon"><svg class="${className}-${icon}"><use href="#safiricon-${icon}"></use></svg></span>`;
}